'use client';

import { ComponentPropsWithoutRef } from 'react';
import { Icon } from '@/shared/ui/icon';
import type { IconName } from '@/shared/ui/icon';
import { AddressIconOption } from './types';

type Props = ComponentPropsWithoutRef<'svg'> & {
    icon: AddressIconOption;
};

const MAP: Record<AddressIconOption, IconName> = {
    [AddressIconOption.MAP_PIN]: 'map-pin',
    [AddressIconOption.ORDER]: 'bag',
    [AddressIconOption.CART]: 'cart',
    [AddressIconOption.DELIVERY]: 'truck-fast',
    [AddressIconOption.STAR]: 'star',
    [AddressIconOption.DRONE]: 'drone',
    [AddressIconOption.CALENDAR]: 'calendar',
    [AddressIconOption.FIRE]: 'fire',
    [AddressIconOption.HEART]: 'heart',
    [AddressIconOption.CURRENT_LOCATION]: 'current-location',
    [AddressIconOption.OTHER]: 'map-pin',
};

export const AddressIcon = ({ icon, ...props }: Props) => {
    return <Icon name={MAP[icon?.toLowerCase() as AddressIconOption]} {...props} />;
};
